import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {TransportService} from "./transport.service";
import {Offcanvas} from "../form.offcanvas";
import {FeeManagementService} from "../feesmanage/feesmanage.service";
import {ScriptLoader} from "../script-loader";
import {FormValidator} from "../form.validator";
import * as registrationStrings from "../stringFiles/registration.json";
import { TranslateService ,LangChangeEvent} from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
// import {nullSafeIsEquivalent} from "@angular/compiler/src/output/output_ast";

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var AmCharts: any;
declare var customToastr: any;
declare var google: any;

@Component({
  selector: 'app-transport',
  templateUrl: './transport.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/buttons.dataTables.min.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
   /* './jquery.dataTables.min.css',*/
    './export.css',
    './buttons.dataTables.min.css',
    './transport.component.css'],
  encapsulation: ViewEncapsulation.None,

  providers: [LoginService,TransportService,Offcanvas,FeeManagementService,ScriptLoader,FormValidator]
})
export class TransportComponent implements OnInit {
  private langChangeSubscription: any;
  getAuthToken = localStorage.getItem('usertoken');
  currentAcademic = localStorage.getItem('current_academic');
  academicInfo = {
    current_academic:'',
    current_academic_state:'',
    current_tab:'OVERVIEW',
    academicList:[]
  };
  busStatus = false;
  updateBusStatus = false;
    activeBus = 0;
    inActiveBus = 0;
    totalVehicles = 0;
    busList = [];
    studentBusOptedList = [];
    termName="";
    termDueDate="";
    termStartDate :"";
    termEndDate : "";
    edittermName="";
    edittermDueDate: any ="";
    editTermStartDate :any= "";
    editTermEndDate :any ="";
    termsList   =   [];
    activeBusList = [];
    inactiveBusList = [];
    busDetails: any = {BusName:null,fkStaffId:null,Capacity:null,fkRouteId:null,BusStatus:null,BusInCharge:null};
    busRouteList = [];
    addRoutes = {RouteName:"",StartPoint:"",EndPoint:"",TotalStops:""};
    _addRoutes = {RouteName:"",StartPoint:"",EndPoint:"",TotalStops:""};
    busStopDetail = [];
    driverDetails = [];
    addBus = {BusNumber:"",BusName:"",Capacity:"",fkStaffId:"",DeviceId:"",fkRouteId:"",BusStatus:"",InChargeId:null,current_academic:this.currentAcademic};
    _addBus = {BusNumber:"",BusName:"",Capacity:"",fkStaffId:"",DeviceId:"",fkRouteId:"",BusStatus:"",InChargeId:null,current_academic:this.currentAcademic};
    myData: any = {RouteName:null,StartPoint:null,EndPoint:null,TotalStop:null};
    updateRoutes = {RouteName:"",StartPoint:"",EndPoint:"",TotalStop:""};
    stopDetails: any = {BusStopName:null,Busfare:null};
    updateStops = {BusStopName:"",Busfare:"",Latitude:"",Longitude:""};
    viewStop = [];
    editListStop = [];
    assignRouteStop = [{FkRouteId:"",FkStopId:"",stopNumber:""}];
    getSchoolId = localStorage.getItem('schoolinfo') ;
    selectedRoutId = 0;
    selectedRouteDetails = {TotalStop:0,assignedStops:0};
    remainingStopsToAssign = 0;
    selectedBusId = 0;
    selectedBusListType = 'all';
    selectedBusData: any; //= {assignedStudents:'',pkRouteId:''};
    addStop = {BusStopName:"",fare:"",Latitude:"",Longitude:"",totalInstallments:""};
    _addStop = {BusStopName:"",fare:"",Latitude:"",Longitude:"",totalInstallments:""};
    selectedStopId = 0;
    updateBus = {BusName:"",Capacity:"",fkStaffId:"",DeviceId:"",fkRouteId:"",BusStatus:"",BusInCharge:null};
    assignStopsPopupClone = null;
    installments    =   [];
    termDetails={};
    selectedTermId;
    termCount=0;
  lastStopToAssign;
  totalStopToAssign;
  initialAcademicId = "";
  activeTab = "BUS";
  private map: any;
  private marker: any;
  private addMap: any;
  private addMarker: any;
  private updateCoordinates: (lat: number, lng: number) => void;
  private updateAddCoordinates: (lat: number, lng: number) => void;
  strings: any;


  constructor(private router: Router, private loginservice: LoginService,private transportservice: TransportService, private offcanvas:Offcanvas, private feeService: FeeManagementService, private scriptLoader:ScriptLoader, private formValidator:FormValidator,private translate : TranslateService) {
    this.strings = registrationStrings;
  }
  loginMode = "";
  isValidToken(){
    var isValidToken = false;
    var isValidSchool = 0;
    this.loginservice.isValidToken(this.getAuthToken)
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if(data.errorcode == 10010){
            this.router.navigate(['/suspended']);
          }
          else if(isValidToken==true){
            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (isValidData:any) => {
                  isValidSchool = isValidData.schoolExist;
                  this.getSchoolId = localStorage.getItem('schoolinfo');
                  if(isValidSchool!=1){
                    this.router.navigate(['/login']);
                  }
                  else if(this.loginMode == "STAFF"){
                    this.router.navigate(['/exams']);
                  }
                  else{
                    this.initializeAcademicData();
                  }
                },
                error => {}
              );
          }else{
            this.router.navigate(['/login']);
          }
        },
        error =>{

        }
      );
  }

  convertToNumber(string) {
    return parseInt(string);
  }

  initializeAcademicData(){
    this.feeService.fetchAcademicList()
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          }
          else {
            data = data.academicList;
            if(data && data.length > 0){
              this.academicInfo.academicList = data;
              let index_of_current = null;
              for(let i=0;i<this.academicInfo.academicList.length; i++){
                this.academicInfo.academicList[i].current = false;
                this.academicInfo.academicList[i].notstarted = false;
                this.academicInfo.academicList[i].completed = false;
                if (this.academicInfo.academicList[i].InActive == 0) {
                  index_of_current = i;
                  this.academicInfo.academicList[i].current = true;
                  this.academicInfo.current_academic = this.academicInfo.academicList[i].pkAcademicId;
                  this.academicInfo.current_academic_state = this.academicInfo.academicList[i].current ? 'RUNNING' : this.academicInfo.academicList[i].completed ? 'COMPLETED' : 'NOT_STARTED'
                  localStorage.setItem('current_academic',this.academicInfo.current_academic);
                  this.initialAcademicId = localStorage.getItem('current_academic');
                }
                else if (this.academicInfo.academicList[i].InActive == 1) {
                  let sDate = new Date(this.academicInfo.academicList[i].StartDate);
                  let eDate = new Date(this.academicInfo.academicList[i].EndDate);
                  if (eDate < new Date()) {
                    this.academicInfo.academicList[i].completed = true;
                  }
                  else {
                    this.academicInfo.academicList[i].notstarted = true;
                  }
                }
              }
              if(index_of_current != null){
                let _index_of_current = index_of_current == 0 ? 0 : index_of_current-1;
               // this.academicInfo.academicList = this.academicInfo.academicList.slice(_index_of_current,index_of_current+2);
              }
            }
            this.getTransportCall(this.activeTab);
          }
        },
        error => {

        }
      );
  }

isAcademicChanged(){
    //return localStorage.getItem('current_academic') === this.initialAcademicId;
    return true;
  }


  academicChanged(){
    for(let i=0;i<this.academicInfo.academicList.length; i++){
      if(this.academicInfo.academicList[i].pkAcademicId == this.academicInfo.current_academic){
        this.academicInfo.current_academic_state = this.academicInfo.academicList[i].current ? 'RUNNING' : this.academicInfo.academicList[i].completed ? 'COMPLETED' : 'NOT_STARTED'
      }
    }
    localStorage.setItem('current_academic',this.academicInfo.current_academic);

    this.assignStop();
    this.getTransportCount();
    this.getAllBuses();
    this.getActiveBuses();
    this.getInActiveBuses();
    this.getRouteList();
    this.getBusStop();
    this.getDriverList();
    this.getAllStopTerms();
  }




  getTransportCount(){
    this.transportservice.fetchTransportCount(localStorage.getItem('schoolinfo'),this.getAuthToken)
      .subscribe(
        (data: any) =>{
          this.activeBus = data[0].ActiveBus.toLocaleString('en');
          this.inActiveBus = data[0].InActiveBus.toLocaleString('en');
          this.totalVehicles = data[0].TotalVehicles.toLocaleString('en');
        },
        error => {

        }
      );
  }

  destroyDataTable(table){
    if ($.fn.DataTable.isDataTable('#'+table)) {
      $('#'+table).DataTable().clear().destroy();
    }
  }

 initializeDataTable(table, fileName) {
  setTimeout(() => {
    this.translate.get([
      'dataTables.emptyTable',
      'dataTables.search',
      'dataTables.lengthMenu',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.paginate.next',
      'dataTables.paginate.previous',
      'dataTables.buttons.copy',
      'dataTables.buttons.excel',
      'dataTables.buttons.csv'
    ]).subscribe(translations => {
      const utilFun = {
        getText() {
          return fileName;
        }
      };

      $('#' + table).DataTable({
        order: [[0, 'asc']],
        language: {
          emptyTable: translations['dataTables.emptyTable'],
          search: translations['dataTables.search'],
          lengthMenu: translations['dataTables.lengthMenu'],
          info: translations['dataTables.info'],
          infoEmpty: translations['dataTables.infoEmpty'],
          paginate: {
            next: translations['dataTables.paginate.next'],
            previous: translations['dataTables.paginate.previous']
          }
        },
        dom: 'lfBrtip',
        buttons: [
          $.extend(true, {}, {
            extend: 'copyHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.copy']
          }),
          $.extend(true, {}, {
            extend: 'excelHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.excel']
          }),
          $.extend(true, {}, {
            extend: 'csvHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.csv']
          })
        ]
      });
    });
  }, 500);
}


  getAllBuses(){
    this.busList = [];
    this.destroyDataTable('all-transport');
    this.transportservice.fetchAllBuses(localStorage.getItem('schoolinfo'),this.getAuthToken)
      .subscribe(
        (data: any) => {
          if(data && data.length > 0){
            this.busList = JSON.parse(JSON.stringify(data));
            this.translate.get('all_buses_export').subscribe((translatedTitle: string) => {
              this.initializeDataTable('all-transport', translatedTitle);
            });
          }
          
        },
        error => {

        }
      );
  }
  closeStudentOptBusList(){
    this.offcanvas.handleOffcanvasOpen('#studentListForOptedBus');
  }
  studentBusOptedListLoading = false;
  getBusOptedStudentDetailsList(busList){
    this.studentBusOptedListLoading = true;
    this.offcanvas.handleOffcanvasOpen("#studentListForOptedBus");
    this.studentBusOptedList = [];
    this.destroyDataTable('student-list-for-opted-bus');
    this.transportservice.fetchStudentDetailsForOptedBus(busList.pkBusId,localStorage.getItem('schoolinfo'),this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.studentBusOptedListLoading = false;
          this.studentBusOptedList = JSON.parse(JSON.stringify(data));
          if(this.studentBusOptedList.length > 0){
            this.initializeDataTable('student-list-for-opted-bus',busList.BusName);
          }
        },
        error => {
          this.studentBusOptedListLoading = false;
          }
      );

  }
  getActiveBuses(){
    this.activeBusList = [];
    this.destroyDataTable('active-transport');

    this.transportservice.fetchActiveBuses(localStorage.getItem('schoolinfo'),this.getAuthToken)
      .subscribe(
        (data: any) => {

          if(data && data.length > 0){
            this.activeBusList = JSON.parse(JSON.stringify(data));
            this.translate.get('active_transport_export').subscribe((translatedTitle: string) => {
              this.initializeDataTable('active-transport', translatedTitle);
            });
          }
          
        },
        error => {

        }
      );
  }
  getInActiveBuses(){
    this.inactiveBusList = [];
    this.destroyDataTable('inactive-transport');
    this.transportservice.fetchInActiveBuses(localStorage.getItem('schoolinfo'),this.getAuthToken)
      .subscribe(
        (data: any) => {
          if(data && data.length > 0){
            this.inactiveBusList = JSON.parse(JSON.stringify(data));
            this.translate.get('inactive_transport_export').subscribe((translatedTitle: string) => {
              this.initializeDataTable('inactive-transport', translatedTitle);
            });
          }
        
        },
        error => {

        }
      );
  }
  updateBusPopup(){
    $('#update-bus').modal('show');
  }
  deleteBusPopup(){
    $('#delete-bus').modal('show');
  }

  busDetail(Iablist,listType){
    this.selectedBusData = Iablist;
    this.selectedBusListType = listType;
    this.selectedBusId =Iablist.pkBusId;
    this.busDetails = [];
      this.transportservice.fetchBusesDetail(this.getAuthToken,Iablist.pkBusId)
        .subscribe(
          (data: any) => {

            this.busDetails = data[0];
            this.getRouteList();

          },
          error => {

          }
        );
  }
  getRouteList(){
    this.busRouteList = [];
    this.destroyDataTable('routes-table');
    this.transportservice.fetchBusesRoute(this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (var i = 0; i < data.length; i++){
            this.busRouteList.push(data[i]);
            if (data.length - 1 == i) {
              this.translate.get('route_list_export').subscribe((translatedTitle: string) => {
              this.initializeDataTable('routes-table', translatedTitle);
            });
            }
          }
        },
        error => {

        }
      );
  }

  async showRouteWarning(route){
    if(route.assignedStops < route.TotalStop){
      const translation = await firstValueFrom(this.translate.get(['pleaseAssignAll', 'stopsTo', 'rightNowOnly', 'stops', 'stop', 'assigned']))
      customToastr(translation['pleaseAssignAll'] + " <b>"+route.TotalStop+"</b> "+ translation['stopsTo']+" <b>"+route.RouteName+"</b>"+ translation['rightNowOnly']+" <b>"+route.assignedStops+"</b> " +(route.assignedStops > 1 ? translation['stops'] : translation['stop'])+ translation['assigned'],'warning');
    }
  }

  getBusStop(){
    this.busStopDetail = [];
    this.destroyDataTable('stops_list_table');
    this.transportservice.fetchBusStop(this.academicInfo.current_academic,this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.busStopDetail = data;
          this.translate.get('stops_list_export').subscribe((translatedTitle: string) => {
              this.initializeDataTable('stops_list_table', translatedTitle);
            });
        },
        error => {

        }
      );
  }
  async addBusRoute(addroutes){
    $('#Route-Status').show();
    if (addroutes.RouteName !=null && addroutes.RouteName !="" && addroutes.RouteName != undefined && addroutes.StartPoint != null && addroutes.StartPoint !="" && addroutes.StartPoint != undefined && addroutes.EndPoint !=null && addroutes.EndPoint !="" && addroutes.EndPoint != undefined && addroutes.TotalStops !=null && addroutes.TotalStops !="" && addroutes.TotalStops != undefined){
      this.transportservice.insertBusRoute(this.addRoutes.RouteName,this.addRoutes.StartPoint,this.addRoutes.EndPoint,this.addRoutes.TotalStops,this.getAuthToken)
        .subscribe(
          async (data: any) => {
            this.addRoutes = JSON.parse(JSON.stringify(this._addRoutes));
            $('#Route-Status').hide();
            if(data.status == true){
              const routeIsAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('routeIsAddedSuccessfully')); 
              customToastr(routeIsAddedSuccessfullyTranslation, 'success');
              $("#addroutepopupclose").trigger("click");
              this.getRouteList();
            }
            else{
              const routeIsNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('routeIsNotAddedPleaseTryAgain')); 
              customToastr(routeIsNotAddedPleaseTryAgainTranslation, 'error');
            }
          },
          error => {

          }
        );
    }
    else {
      $('#Route-Status').hide();
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }
  getDriverList(){
    this.driverDetails = [];
    this.transportservice.fetchDriverList(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.driverDetails = data;
        },
        error => {

        }
      );
  }
  async addBuses(addbus){
    this.busStatus = true;
   const validateBusname =  this.formValidator.validateBusInfoFields(addbus.BusName,"Bus name")
   const validateBusNumber =this.formValidator.validateBusInfoFields(addbus.BusNumber,"Bus number") 
   const validateBusCapacity =  this.formValidator.validateBusInfoFields(addbus.Capacity,"Bus capacity") 
   const validateBusDeviceId =  this.formValidator.validateBusInfoFields(addbus.DeviceId,"Tracking device")
    if (!validateBusNumber && !validateBusname && !validateBusCapacity && this.formValidator.validateIsDataForString(addbus.fkStaffId) && !validateBusDeviceId && this.formValidator.validateIsDataForString(addbus.fkRouteId) && this.formValidator.validateIsDataForString(addbus.BusStatus)){
     
      this.transportservice.addNewBus(this.addBus,this.getAuthToken)
        .subscribe(
          async (data: any) => {
            this.addBus = JSON.parse(JSON.stringify(this._addBus));
            this.busStatus = false;
            if(data.status == true){
              const busIsAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('busIsAddedSuccessfully')); 
              customToastr(busIsAddedSuccessfullyTranslation, 'success');
              $('.backdrop').trigger("click");
              this.getAllBuses();
              this.getTransportCount();
              this.getActiveBuses();
              this.getInActiveBuses();
            }
            else if(data.status == false) {
              const busIsAlreadyExistTranslation = await firstValueFrom(this.translate.get('busIsAlreadyExist')); 
              customToastr(busIsAlreadyExistTranslation, 'error');
            }
            else{
              const busIsNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('busIsNotAddedPleaseTryAgain')); 
              customToastr(busIsNotAddedPleaseTryAgainTranslation, 'error');
            }
          },
          error => {
            this.busStatus = false;
          }
        );
    }
    else if(validateBusname){
      this.busStatus = false;
      customToastr(validateBusname,'error');
    }else if(validateBusNumber){
      this.busStatus = false;
      customToastr(validateBusNumber,'error');
    }else if(validateBusCapacity){
      this.busStatus = false;
      customToastr(validateBusCapacity,'error');
    }else if(validateBusDeviceId){
      this.busStatus = false;
      customToastr(validateBusDeviceId,'error');
    }else{
      this.busStatus = false;
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }

  assignRoutePopup(){
    $('#assign_stop').modal('show');
  }
  editRoutePopup(){
    $('#edit-routes').modal('show');
  }

  deleteRoutePopup(){
    $('#delete-routes').modal('show');
  }
  routeDetail(routeId,route){
    if(this.assignStopsPopupClone != null){
    }

    this.selectedRoutId = routeId;
    this.selectedRouteDetails = route;
    this.remainingStopsToAssign = this.selectedRouteDetails.TotalStop;

    this.transportservice.fetchRouteDetail(this.getAuthToken, routeId)
      .subscribe(
        (data: any) => {
          var h = this;
          setTimeout(function () {
            h.myData = data[0];
          },100);
        },
        error => {

        }
      );
  }
  async updateBusRoute(updateRoutes){
    $('#updateRoute-Status').show();
    this.updateRoutes.RouteName = $('.route_Name').val();
    this.updateRoutes.StartPoint = $('.startpoint').val();
    this.updateRoutes.EndPoint = $('.endpoint').val();
    this.updateRoutes.TotalStop = $('.totalStop').val();

    if (updateRoutes.RouteName !=null && updateRoutes.RouteName !="" && updateRoutes.RouteName != undefined && updateRoutes.StartPoint != null && updateRoutes.StartPoint !="" && updateRoutes.StartPoint != undefined && updateRoutes.EndPoint !=null && updateRoutes.EndPoint !="" && updateRoutes.EndPoint != undefined && updateRoutes.TotalStop !=null && updateRoutes.TotalStop !="" && updateRoutes.TotalStop != undefined){
      if(parseInt(this.updateRoutes.TotalStop) >= this.selectedRouteDetails.assignedStops){
        this.transportservice.updateBusRoute(this.updateRoutes.RouteName,this.updateRoutes.StartPoint,this.updateRoutes.EndPoint,this.updateRoutes.TotalStop,this.selectedRoutId,this.getAuthToken)
          .subscribe(
            async (data: any) => {
              $('#updateRoute-Status').hide();
              if(data.status == true){
                const routeIsUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('routeIsUpdatedSuccessfully')); 
                customToastr(routeIsUpdatedSuccessfullyTranslation, 'success');
                $("#updateroutepopupclose").trigger("click");
                this.getRouteList();
              }
              else{
                const routeIsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('routeIsNotUpdatedPleaseTryAgain')); 
                customToastr(routeIsNotUpdatedPleaseTryAgainTranslation, 'error');
              }
            },
            error => {

              }
          );
      }
      else{
        $('#updateRoute-Status').hide();
        const translation = await firstValueFrom(this.translate.get(['youCannotReduceNumberOfStopsLessThanTo', 'already', 'stopsAreAssignedToThisRoute']));
        customToastr( translation['youCannotReduceNumberOfStopsLessThanTo']+ " <b>"+this.selectedRouteDetails.assignedStops+"</b>, "+ translation['already'] +" "+this.selectedRouteDetails.assignedStops+translation['stopsAreAssignedToThisRoute'],'error');
      }
    }
    else {
      $('#updateRoute-Status').hide();
      const pleaseFillAllFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllFields')); 
      customToastr(pleaseFillAllFieldsTranslation, 'error');
    }
  }
  deleteRouteDetail(){
    this.transportservice.deleteRouteDetail(this.getAuthToken,this.selectedRoutId)
      .subscribe(
        async (data: any) => {
          if(data.status == true){
            const routeDeletedTranslation = await firstValueFrom(this.translate.get('routeDeleted')); 
            customToastr(routeDeletedTranslation, 'success');
            $("#closedeleteroutepopup").trigger("click");
            this.getRouteList();
          }
          else if (data.status == false){
            const routeIsUsedInBusCannotBeDeletedTranslation = await firstValueFrom(this.translate.get('routeIsUsedInBusCannotBeDeleted')); 
            customToastr(routeIsUsedInBusCannotBeDeletedTranslation, 'error')
            $("#closedeleteroutepopup").trigger("click");
          }
          else{
            const routeNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('routeNotDeletedPleaseTryAgain')); 
            customToastr(routeNotDeletedPleaseTryAgainTranslation, 'error');
          }

        },
        error => {

        }
      );
  }

  installmentCountChange(count){
        //Generate
        this.addStop.totalInstallments=count;
        this.installments=[];
        for(var i=0;i<count;i++){
            var ins =   {
                count:i
            }
            this.installments.push(ins);
        }
    }

  async addBusStop(addstops){
    $('#addStop-Status').show();
    if (addstops.BusStopName != null && addstops.BusStopName != "" && addstops.BusStopName != undefined && addstops.fare != null && addstops.fare != "" && addstops.fare != undefined ){
      this.transportservice.addBusStop(this.addStop.BusStopName,this.addStop.fare,this.addStop.Latitude,this.addStop.Longitude,this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if(data.status == true){
              this.addStop = JSON.parse(JSON.stringify(this._addStop))
              $('#addStop-Status').hide();
              const stopsIsAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('stopsIsAddedSuccessfully')); 
              customToastr(stopsIsAddedSuccessfullyTranslation, 'success');
              $("#addstopspopupclose").trigger("click");
              this.getBusStop();
            }
            else{
              
              customToastr(!data.status ? data.message : 'Stops is not added please try again','error');
            }
          },
          error => {

            }
        );
    }
    else {
      $('#addStop-Status').hide();
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }

  offcanvasAddTransport(){
    this.offcanvas.handleOffcanvasOpen("#offcanvas-add-trans");
    this.getRouteList();
    this.getDriverList();
    this.clearAddBusData();
  }


  stopDetail(stopId){
    this.selectedStopId = stopId;
    this.transportservice.fetchStopDetail(this.getAuthToken,stopId)
      .subscribe(
        (data: any) => {
          this.stopDetails = data[0];
        },
        error => {

        }
      );
  }
  async updateBusStop(updateStops){
    $('#stops-Status').show();
    this.updateStops.BusStopName = $('.stop-name').val();
    this.updateStops.Busfare = $('.stop-fare').val();
    this.updateStops.Latitude = this.stopDetails.Latitude;
    this.updateStops.Longitude = this.stopDetails.Longitude;
    if (updateStops.BusStopName !=null && updateStops.BusStopName !="" && updateStops.BusStopName != undefined && updateStops.Busfare !=null && updateStops.Busfare !="" && updateStops.Busfare != undefined){
      this.transportservice.updateBusStop(this.updateStops.BusStopName,this.updateStops.Busfare,this.updateStops.Latitude,this.updateStops.Longitude,this.selectedStopId,this.getAuthToken)
        .subscribe(
          async (data: any) => {
            $('#stops-Status').hide();
            if(data.status == true){
              const stopsIsUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('stopsIsUpdatedSuccessfully')); 
              customToastr(stopsIsUpdatedSuccessfullyTranslation, 'success');
              $("#updateStopspopupclose").trigger("click");
              this.getBusStop();
            }
            else{
              if(data.message == "FEES_PAID"){
                const stopsIsNotUpdatedSomeStudentsAreAlreadyPaidFeesTranslation = await firstValueFrom(this.translate.get('stopsIsNotUpdatedSomeStudentsAreAlreadyPaidFees')); 
                customToastr(stopsIsNotUpdatedSomeStudentsAreAlreadyPaidFeesTranslation, 'error');
              }else if(data.message == "AlreadyExist"){
                const stopAlreadyExistWithSameNamePleaseChangeItTranslation = await firstValueFrom(this.translate.get('stopAlreadyExistWithSameNamePleaseChangeIt')); 
                customToastr(stopAlreadyExistWithSameNamePleaseChangeItTranslation, 'error');
              }
              else {
                const stopsIsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('stopsIsNotUpdatedPleaseTryAgain')); 
                customToastr(stopsIsNotUpdatedPleaseTryAgainTranslation, 'error');
              }
            }
          },
          error => {

          }
        );
    }
    else {
      $('#stops-Status').hide();
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }
  deleteStopDetail(){
    this.transportservice.deleteStopDetail(this.getAuthToken,this.selectedStopId)
      .subscribe(
        async (data: any) => {
          if(data.status == true){
            const stopDeletedTranslation = await firstValueFrom(this.translate.get('stopDeleted')); 
            customToastr(stopDeletedTranslation, 'success');
            $("#closedeletestoppopup").trigger("click");
            this.getBusStop();
          }
          else if (data.status == false){
            const stopIsUsedInRouteCannotBeDeleteTranslation = await firstValueFrom(this.translate.get('stopIsUsedInRouteCannotBeDelete')); 
            customToastr(stopIsUsedInRouteCannotBeDeleteTranslation, 'error');
            $("#closedeletestoppopup").trigger("click");
          }
          else{
            const stopNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('stopNotDeletedPleaseTryAgain')); 
            customToastr(stopNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {

        }
      );
  }
  startingStopToAssign;
    viewStopForRoute(routeId,isEdit){
        this.startingStopToAssign =   routeId;
        for(var i=0;i<this.busRouteList.length;i++){
            if(routeId == this.busRouteList[i].pkRouteId){
              this.startingStopToAssign   =   this.busRouteList[i].StartPoint;
              this.lastStopToAssign   =   this.busRouteList[i].EndPoint;
              this.totalStopToAssign  =   this.busRouteList[i].TotalStop;
            }
        }
    if(isEdit){
      $('#addanotherStopParent').find(".roots_for_bus").remove();
      $("#addmoreStop").hide();
      $("#assignStopsSavebutton").hide();
      this.translate.get('pleaseWaitFetchingStops').subscribe((translatedText: string) => { 
        $('#addanotherStopParent').append(`<div class="roots_for_bus text-center">${translatedText}</div>`)
      })
    }
    this.transportservice.fetchStopForRoute(this.getAuthToken,routeId)
      .subscribe(
        (data: any) => {
          if(isEdit){
            this.editListStop = data;
            this.editStopShowExistingStops();
          }
          else{
            this.viewStop = data;
          }

        },
        error => {

        }
      );
  }

  async assignStopForRoute(assignroutestop){
    $('#stopsAssign-Status').show();
    var reqObj = [];
    var valid = true;
    var stops = $('#addanotherStopParent').find(".roots_for_bus").map(function(index,ele){
      if($(ele).find("#stoplist").attr("disabled") != 'disabled'){
        var stopId =  $(ele).find(".get-select-value").val();
        var stopNumber = $(ele).find(".get-stop-number").val();
        if(stopId && stopId != "" && stopNumber && stopNumber != ""){
          reqObj.push({stopId:stopId,stopNumber:stopNumber});
        }
        else{
          valid = false;
        }
      }

    });
    if(valid){
      if (reqObj.length > 0 ){
        this.transportservice.assignStopForRoute(reqObj,this.selectedRoutId,this.getAuthToken)
          .subscribe(
            async (data: any) => {
              $('#stopsAssign-Status').hide();
              if(data.status == true){
                this.getRouteList();
                const stopIsAssignToRouteSuccessfullyTranslation = await firstValueFrom(this.translate.get('stopIsAssignToRouteSuccessfully')); 
                customToastr(stopIsAssignToRouteSuccessfullyTranslation, 'success');
                $("#assignstoppopupclose").trigger("click");
              }
              else if(data.status == false){
               const stopIsAlreadyExistInThisRouteTranslation = await firstValueFrom(this.translate.get('stopIsAlreadyExistInThisRoute')); 
               customToastr(stopIsAlreadyExistInThisRouteTranslation, 'error');
              }
              else{
               const stopIsNotAssignToRoutePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('stopIsNotAssignToRoutePleaseTryAgain')); 
               customToastr(stopIsNotAssignToRoutePleaseTryAgainTranslation, 'error');
              }
            },
            error => {

              }
          );
      }
      else {
        $('#stopsAssign-Status').hide();
        const provideAddAStopToSaveTranslation = await firstValueFrom(this.translate.get('provideAddAStopToSave')); 
        customToastr(provideAddAStopToSaveTranslation, 'error');
      }

    }
    else{
      $('#stopsAssign-Status').hide();
      const provideProperStopDetailsTranslation = await firstValueFrom(this.translate.get('provideProperStopDetails')); 
      customToastr(provideProperStopDetailsTranslation, 'error');
    }

  }

  deleteBusDetail(){
    this.transportservice.deleteBusDetail(this.getAuthToken,this.selectedBusId)
      .subscribe(
        async (data: any) => {
          if(data.status == true){
            const busDeletedTranslation = await firstValueFrom(this.translate.get('busDeleted')); 
            customToastr(busDeletedTranslation, 'success');
            $("#deletebuspopup").trigger("click");
            this.getAllBuses();
            this.getTransportCount();
            this.getActiveBuses();
            this.getInActiveBuses();
          }
          else if(data.message){
            $("#deletebuspopup").trigger("click");
            const deleteBusTranslation = await firstValueFrom(this.translate.get('deleteBus')); 
            customToastr(data.message,'error',deleteBusTranslation);
          }
          else{
            const busNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('busNotDeletedPleaseTryAgain')); 
            customToastr(busNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {

        }
      );
  }

  selectedUpdateRoute(value){
    this.updateBus.fkRouteId = value;
  }

  async updateBusDetail(UpdateBus){
    this.updateBusStatus = true;
    this.updateBus = this.busDetails;
    if (this.formValidator.validateIsDataForString(UpdateBus.BusName) && this.formValidator.validateIsDataForString(UpdateBus.Capacity) && this.formValidator.validateIsDataForString(UpdateBus.fkStaffId) && this.formValidator.validateIsDataForString(UpdateBus.fkRouteId) && this.formValidator.validateIsDataForString(UpdateBus.BusStatus)){
      if(this.selectedBusData.assignedStudents <=  this.updateBus.Capacity){
        if(this.selectedBusData.pkRouteId == this.updateBus.fkRouteId){
          this.updateBusNext();
        }
        else{
          if(this.selectedBusData.assignedStudents > '0'){
            this.updateBusStatus = false;
            const translation = await firstValueFrom(this.translate.get(['notAllowedToChangeBusRouteAlready', 'studentsAreAssignedToThisBus', 'updateBusDetails']));
            customToastr(translation.notAllowedToChangeBusRouteAlready + " <b>"+this.selectedBusData.assignedStudents+"</b> " + translation.studentsAreAssignedToThisBus,'error',translation.updateBusDetails)
            //customToastr("By changing route of the bus will affect students(<b>"+this.selectedBusData.assignedStudents+"</b>) assigned to this bus, Please select a bus where these <b>"+this.selectedBusData.assignedStudents+"</b> students should assign",'error','Update Bus Details')
          }
          else{
            this.updateBusNext();
          }
        }

      }
      else{
        this.updateBusStatus = false;
        const translation = await firstValueFrom(this.translate.get(['notAllowedToChangeBusCapacityTo', 'studentsAreAssignedToThisBus', 'updateBusDetails', 'already']));
        customToastr( translation.notAllowedToChangeBusCapacityTo + " <b>"+this.updateBus.Capacity+"</b>, "+ translation.already+" <b>"+this.selectedBusData.assignedStudents+"</b> " + translation.studentsAreAssignedToThisBus,'error',translation.updateBusDetails)
      }
    }
    else {
      this.updateBusStatus = false;
      const pleaseFillAllFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllFields')); 
      customToastr(pleaseFillAllFieldsTranslation, 'error');
    }
  }

  updateBusNext(){
    this.transportservice.updateBus(this.updateBus,this.selectedBusId,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          this.updateBusStatus = false;
          if(data.status == true){
            const busUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('busUpdatedSuccessfully')); 
            customToastr(busUpdatedSuccessfullyTranslation, 'success');
            $("#editbuspopup").trigger("click");
            this.getAllBuses();
            this.getTransportCount();
            if(this.selectedBusListType == 'active'){
              this.getActiveBuses();
            }
            else if(this.selectedBusListType == 'inactive'){
              this.getInActiveBuses();
            }
          }
          else{
            const busNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('busNotUpdatedPleaseTryAgain')); 
            customToastr(busNotUpdatedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {

          }
      );
  }

  initscript(){
    $(document).ready(function() {
      $('#all-transport').DataTable( {
        dom: 'Bfrtip',
        buttons: [
          'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      } );
      $('#student-list-for-opted-bus').DataTable( {
        dom: 'Bfrtip',
        buttons: [
          'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      } );

      $('#active-transport').DataTable( {
        dom: 'Bfrtip',
        buttons: [
          'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      } );
      $('#inactive-transport').DataTable( {
        dom: 'Bfrtip',
        buttons: [
          'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      } );
      $('#routes-table').DataTable();
      $('#stops-table').DataTable();

      /*sidedrawer*/
      $('.add-new-vehicle').attr('href','#offcanvas-add-trans');
      $('.gradeX.all-trans').attr('href','#offcanvas-view-all-trans');
      /**/
    } );

  }

  options = {
    "type": "serial",
    "theme": "light",
    "dataProvider": []

  };
//180042525252, 9972600036, 08046089444
editStopShowExistingStops() {
  this.translate.get(['selectStop', 'stopNumber']).subscribe(translations => {
    const selectStopText = translations['selectStop'];
    const stopNumberText = translations['stopNumber'];

    this.remainingStopsToAssign = this.selectedRouteDetails.TotalStop;
    const h = this;

    $('#addanotherStopParent').find(".roots_for_bus").remove();

    if (this.editListStop.length > 0) {
      this.editListStop.forEach(function (item) {
        let id = "stoplist_" + item.pkBusStopId;
        let stopId = "stopnumber_" + item.pkBusStopId;

        let html = '<div class="row roots_for_bus" id="addanotherStop">' +
          '<form class="form">' +
          '<div class="form-group col-md-6">' +
          '<select id="' + id + '" name="' + id + '" class="form-control get-select-value" style="color: rgba(49, 53, 52, 0.51);font-size: small;">' +
          '<option value="">' + selectStopText + '</option>';

        h.busStopDetail.forEach(function (s) {
          html += '<option value="' + s.PkBusStopId + '">' + s.BusStopName + '</option>';
        });

        html += '</select>' +
          '</div>' +
          '<div class="form-group col-md-6">' +
          '<input type="text" class="form-control get-stop-number" id="' + stopId + '" name="' + stopId + '">' +
          '<label for="' + stopId + '">' + stopNumberText + '</label>' +
          '</div>' +
          '</form>' +
          '</div>';

        var _html = $(html);
        _html.find("#" + id).val(item.pkBusStopId);
        _html.find("#" + id).attr("disabled", true);
        _html.find("#" + stopId).val(item.StopNumber);
        _html.find("#" + stopId).attr("disabled", true);

        $('#addanotherStopParent').append(_html);
        h.remainingStopsToAssign = h.remainingStopsToAssign - 1;
      });
    } else {
      var html = '<div class="row roots_for_bus" id="addanotherStop">' +
        '<form class="form">' +
        '<div class="form-group col-md-6">' +
        '<select id="stoplist" name="stoplist" class="form-control get-select-value" style="color: rgba(49, 53, 52, 0.51);font-size: small;">' +
        '<option value="">' + selectStopText + '</option>';

      h.busStopDetail.forEach(function (s) {
        html += '<option value="' + s.PkBusStopId + '">' + s.BusStopName + '</option>';
      });

      html += '</select>' +
        '</div>' +
        '<div class="form-group col-md-6">' +
        '<input type="text" class="form-control get-stop-number" id="stopnumber" disabled="disabled" name="stopnumber" value="1">' +
        '<label for="stopnumber">' + stopNumberText + '</label>' +
        '</div>' +
        '</form>' +
        '</div>';

      h.remainingStopsToAssign = h.remainingStopsToAssign - 1;
      $("#assignStopsSavebutton").show();
      $('#addanotherStopParent').append(html);
      $('#stoplist').val(this.startingStopToAssign);
    }

    if (this.remainingStopsToAssign > 0) {
      $("#addmoreStop").show();
      this.assignStop();
    }
  });
}


private generateStopRowHtml({
  stopId,
  stopNumber,
  selectedValue = '',
  disabled = false,
  selectStopText,
  stopNumberText
}: {
  stopId: string | number,
  stopNumber: number,
  selectedValue?: string | number,
  disabled?: boolean,
  selectStopText: string,
  stopNumberText: string
}): any {
  const id = `stoplist_${stopId}`;
  const numberId = `stopnumber_${stopId}`;

  let html = `
  <div class="row roots_for_bus" id="addanotherStop">
    <form class="form">
      <div class="form-group col-md-6">
        <select id="${id}" name="${id}" class="form-control get-select-value" style="color: rgba(49, 53, 52, 0.51); font-size: small;">
          <option value="">${selectStopText}</option>`;

  this.busStopDetail.forEach(s => {
    html += `<option value="${s.PkBusStopId}">${s.BusStopName}</option>`;
  });

  html += `</select>
      </div>
      <div class="form-group col-md-6">
        <input type="text" class="form-control get-stop-number" id="${numberId}" name="${numberId}" value="${stopNumber}" ${disabled ? 'disabled' : ''}>
        <label for="${numberId}">${stopNumberText}</label>
      </div>
    </form>
  </div>`;

  const $html = $(html);
  $html.find(`#${id}`).val(selectedValue);

  if (disabled) {
    $html.find(`#${id}`).attr('disabled', true);
    $html.find(`#${numberId}`).attr('disabled', true);
  }

  return $html;
}


  getRemainingStopsToAssign(){
      return this.remainingStopsToAssign;
  };

  clearAddTermData(){
    this.termName = "";
    this.termDueDate = "";
  }
  clearAddStopData(){
    this.addStop = {BusStopName:"",fare:"",Latitude:"",Longitude:"",totalInstallments:""};
    // Clear the input fields when modal is opened
    setTimeout(() => {
      $('#addLatitude').val('');
      $('#addLongitude').val('');
      $('#addSearchLocation').val('');
    }, 100);
  }
  clearAddRouteData(){
    this.addRoutes = {RouteName:"",StartPoint:"",EndPoint:"",TotalStops:""};
  }
  clearAddBusData(){
    this.addBus = {BusNumber:"",BusName:"",Capacity:"",fkStaffId:"",DeviceId:"",fkRouteId:"",BusStatus:"",InChargeId:null,current_academic:this.currentAcademic};
  }

  async addTerms(){
    if(this.termName != null && this.termName != "" && this.termDueDate != null && this.termDueDate != "") {
      let termObj = {
        termName: this.termName,
        termDue: this.termDueDate,
       termStartDate : this.termStartDate!=="" ?this.termStartDate : null,
       termEndDate :  this.termEndDate !=="" ?  this.termEndDate : null
      };
      this.transportservice.addStopTerm(termObj, this.getAuthToken)
        .subscribe(
          async (data: any) => {
            if (data.success) {
              const termAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('termAddedSuccessfully')); 
              customToastr(termAddedSuccessfullyTranslation, 'success');
              this.getAllStopTerms();
              $(".modal-backdrop").trigger("click");
            } else {
              var message = "Failed to add term";
              if (data.errmessage) {
                message = data.errmessage;
              }
              customToastr(message, 'error');
            }

          },
          error => {

            }
        );
    }else{
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }

  getAllStopTerms(){
    this.termsList = [];
    this.destroyDataTable('transport-term');
    this.transportservice.getStopTerms(this.getAuthToken)
      .subscribe(
        (data: any) => {
          if(data.success) {
            this.termsList = JSON.parse(JSON.stringify(data.data));
            this.termCount  =   this.termsList.length;
            this.translate.get('term_list_export').subscribe((translatedTitle: string) => {
              this.initializeDataTable('transport-term', translatedTitle);
            });
          }
        },
        error => {

          }
      );
  }

  deleteTermConfirm(termId){
    this.selectedTermId =   termId;
  }
  deleteTerm(){
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#delete-term-button').text(translatedText); });
    $("#delete-term-button").attr("disabled",true);
    this.transportservice.deleteStopTerms(this.selectedTermId,this.getAuthToken)
      .subscribe(
        async (data: any) => {
          if(data.success) {
            const termDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('termDeletedSuccessfully')); 
            customToastr(termDeletedSuccessfullyTranslation, 'success');
            $("#closedeletetermpopup").trigger("click");
            this.getAllStopTerms();
          }else{
            $("#closedeletetermpopup").trigger("click");
            customToastr(data.errmessage, 'error');
          }
          this.translate.get('delete').subscribe((translatedText: string) => { $('#delete-term-button').text(translatedText); });
          $("#delete-term-button").attr("disabled",false);
        },
        error => {

          }
      );

  }


  editTerm(){
        if(this.edittermName != null && this.edittermName != "" && this.edittermDueDate != "" && this.editTermStartDate != ""  && this.editTermEndDate != "") {
            this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#edit-term-btn').text(translatedText); });
            $("#edit-term-btn").attr("disabled",true);

            var termObj = {
                pkBusStopTermId: this.selectedTermId,
                termName: this.edittermName,
                termDueDate: this.edittermDueDate,
                termStartDate : this.editTermStartDate,
                termEndDate : this.editTermEndDate
            };
            this.transportservice.editStopTerms(termObj, this.getAuthToken)
                .subscribe(
                    async (data: any) => {
                        this.translate.get('save').subscribe((translatedText: string) => { $('#edit-term-btn').text(translatedText); });
                        $("#edit-term-btn").attr("disabled",false);
                        if (data.success) {
                            const termEditedSuccessfullyTranslation = await firstValueFrom(this.translate.get('termEditedSuccessfully')); 
                            customToastr(termEditedSuccessfullyTranslation, 'success');
                            $("#edit-new-term").trigger("click");
                            $(".modal-backdrop").trigger("click");
                            this.edittermName = "";
                            this.edittermDueDate = "";
                            this.getAllStopTerms();
                        } else {
                            $("#edit-new-term").trigger("click");
                            $(".modal-backdrop").trigger("click");
                            customToastr(data.errmessage, 'error');
                        }

                    },
                    error => {

                        }
                );
        }

    }

  termDetail(termId){
        this.selectedTermId =   termId;
        this.transportservice.getTermInfo(this.selectedTermId,this.getAuthToken)
            .subscribe(
                (data: any) => {
                    if(data.success) {
                        var split   =   data.data.termDueDate.split("T");

                        var termDate    =   split[0].split("-");
                        var day         =   termDate[2];
                        var _day        =   parseInt(day)+1;
                        var newDay      =   ""+_day;
                        var month       =   termDate[1];
                        var year        =   termDate[0];
                        var fullDate    =   year+"-"+month+"-"+newDay;
                        this.edittermName=data.data.termName;
                        this.edittermDueDate=data.data.termDueDate ? moment(data.data.termDueDate).format('YYYY-MM-DD') :null;
                        this.editTermStartDate =data.data.termStartDate ? moment(data.data.termStartDate).format('YYYY-MM-DD') :null;
                        this.editTermEndDate =data.data.termEndDate? moment(data.data.termEndDate).format('YYYY-MM-DD') : null ;
                    }else{
                        customToastr(data.errmessage, 'error');
                    }

                },
                error => {

                    }
            );
    }

  assignStop() {
    const h = this;

    this.translate.get(['selectStop', 'stopNumber']).subscribe(translations => {
      const selectStopText = translations['selectStop'];
      const stopNumberText = translations['stopNumber'];

      $("#addmoreStop").on("click", function () {
        const nextStop = $(".roots_for_bus").length + 1;

        if (h.remainingStopsToAssign > 0) {
          $("#assignStopsSavebutton").show();

          let html = `
          <div class="row roots_for_bus new" id="addanotherStop">
            <form class="form">
              <div class="form-group col-md-6">
                <select id="stoplist" name="select13" class="form-control get-select-value" style="color: rgba(49, 53, 52, 0.51); font-size: small;">
                  <option value="">${selectStopText}</option>`;

          h.busStopDetail.forEach(function (s) {
            html += `<option value="${s.PkBusStopId}">${s.BusStopName}</option>`;
          });

          html += `</select>
              </div>
              <div class="form-group col-md-6">
                <input type="text" class="form-control get-stop-number" id="stopnumber" disabled="disabled" name="assignStopNo" value="${nextStop}">
                <label for="stopnumber">${stopNumberText}</label>
              </div>
            </form>
          </div>`;

          $('#addanotherStopParent').append(html);

          if (h.remainingStopsToAssign === 1) {
            $('#addanotherStopParent').find(".roots_for_bus").map(function (index, ele) {
              if ((h.totalStopToAssign - h.remainingStopsToAssign) === index) {
                $(ele).find(".get-select-value").val(h.lastStopToAssign);
              }
            });
          }

          h.remainingStopsToAssign -= 1;

          if (h.remainingStopsToAssign <= 0) {
            $("#addmoreStop").hide();
          } else {
            $("#addmoreStop").show();
          }

        } else {
          $("#addmoreStop").hide();
        }
      });
    });
  }

  private initializeAddMap() {
    // Initialize the map when the add modal is shown
    $('#add-new-stops').on('shown.bs.modal', () => {
      setTimeout(() => {
        // Style the search input and its container
        const searchInput = document.getElementById('addSearchLocation') as HTMLInputElement;
        if (searchInput) {
          searchInput.style.cssText = `
            width: 100%;
            height: 40px;
            padding: 8px 12px;
            font-size: 14px;
            border: 1px solid #ddd;
            border-radius: 4px;
            margin-bottom: 15px;
            outline: none;
            box-shadow: none;
          `;
        }

        // Get map container
        const mapContainer = document.getElementById('addStopLocationMap');
        if (!mapContainer) return;

        const defaultLocation = { lat: 20.5937, lng: 78.9629 }; // Default to center of India
        const mapOptions = {
          center: defaultLocation,
          zoom: 15,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          }
        };

        this.addMap = new google.maps.Map(document.getElementById('addStopLocationMap'), mapOptions);

        // Initialize the autocomplete with more specific options
        const input = document.getElementById('addSearchLocation') as HTMLInputElement;
        if (!input) return;

        // Clear any existing event listeners
        const newInput = input.cloneNode(true) as HTMLInputElement;
        input.parentNode?.replaceChild(newInput, input);
        
        const autocompleteOptions = {
          fields: ['formatted_address', 'geometry', 'name', 'place_id'],
          types: ['geocode', 'establishment'],
          componentRestrictions: { country: 'IN' },
          strictBounds: false
        };
        const autocomplete = new google.maps.places.Autocomplete(newInput, autocompleteOptions);
        
        // Bind autocomplete to the map
        autocomplete.bindTo('bounds', this.addMap);



        // Ensure the autocomplete dropdown appears above the modal
        setTimeout(() => {
          const pacContainers = document.getElementsByClassName('pac-container');
          for (let i = 0; i < pacContainers.length; i++) {
            const container = pacContainers[i] as HTMLElement;
            container.style.zIndex = '10000';
            
            // Ensure container is appended to body to avoid modal stacking context issues
            if (container.parentElement !== document.body) {
              document.body.appendChild(container);
            }
          }
        }, 300);

        // Create a marker for location selection
        this.addMarker = new google.maps.Marker({
          map: this.addMap,
          draggable: true,
          position: defaultLocation,
          animation: google.maps.Animation.DROP
        });

        // Add click listener to map
        this.addMap.addListener('click', (event: any) => {
          const position = event.latLng;
          this.addMarker.setPosition(position);
          this.updateAddCoordinates(position.lat(), position.lng());
        });

        // Update coordinates when marker is dragged
        this.addMarker.addListener('dragend', (event: any) => {
          const position = this.addMarker.getPosition();
          this.updateAddCoordinates(position.lat(), position.lng());
        });

        // Helper method to update coordinates for add modal
        this.updateAddCoordinates = (lat: number, lng: number) => {
          this.addStop.Latitude = lat.toFixed(6);
          this.addStop.Longitude = lng.toFixed(6);
          $('#addLatitude').val(lat.toFixed(6));
          $('#addLongitude').val(lng.toFixed(6));
        };

        // Single consolidated place_changed event listener for add modal
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          
          if (!place.geometry || !place.geometry.location) {
            return;
          }

          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          // If the place has a geometry, then present it on a map
          if (place.geometry.viewport) {
            this.addMap.fitBounds(place.geometry.viewport);
          } else {
            this.addMap.setCenter(place.geometry.location);
            this.addMap.setZoom(17);
          }

          // Update marker position with animation
          this.addMarker.setPosition(place.geometry.location);
          this.addMarker.setAnimation(google.maps.Animation.DROP);

          // Update all latitude and longitude fields
          $('#addLatitude').val(lat.toString());
          $('#addLongitude').val(lng.toString());
          
          // Update the component's data models
          this.addStop.Latitude = lat.toString();
          this.addStop.Longitude = lng.toString();

          // Clear the input field after selection
          (input as HTMLInputElement).value = place.formatted_address || place.name || '';

          // Trigger change event on the input fields
          $('#addLatitude, #addLongitude').trigger('change');
        });

        // Reset map to default location for new stops
        this.addMap.setCenter(defaultLocation);
        this.addMarker.setPosition(defaultLocation);
        this.addMap.setZoom(15);
      }, 300); // Small delay to ensure the modal is fully shown
    });
  }


  currType="";
  private initializeMap() {
    // Initialize the map when the modal is shown
    $('#edit-stops').on('shown.bs.modal', () => {
      setTimeout(() => {
        // Style the search input and its container
        const searchInput = document.getElementById('searchLocation') as HTMLInputElement;
        if (searchInput) {
          searchInput.style.cssText = `
            width: 100%;
            height: 40px;
            padding: 8px 12px;
            font-size: 14px;
            border: 1px solid #ddd;
            border-radius: 4px;
            margin-bottom: 15px;
            outline: none;
            box-shadow: none;
          `;
        }

        // Get map container
        const mapContainer = document.getElementById('stopLocationMap');
        if (!mapContainer) return;

        const defaultLocation = { lat: 20.5937, lng: 78.9629 }; // Default to center of India
        const mapOptions = {
          center: defaultLocation,
          zoom: 15,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          }
        };

        this.map = new google.maps.Map(document.getElementById('stopLocationMap'), mapOptions);

        // Initialize the autocomplete with more specific options
        const input = document.getElementById('searchLocation') as HTMLInputElement;
        if (!input) return;

        // Clear any existing event listeners
        const newInput = input.cloneNode(true) as HTMLInputElement;
        input.parentNode?.replaceChild(newInput, input);
        
        const autocompleteOptions = {
          fields: ['formatted_address', 'geometry', 'name', 'place_id'],
          types: ['geocode', 'establishment'],
          componentRestrictions: { country: 'IN' },
          strictBounds: false
        };
        const autocomplete = new google.maps.places.Autocomplete(newInput, autocompleteOptions);
        
        // Bind autocomplete to the map
        autocomplete.bindTo('bounds', this.map);



        // Ensure the autocomplete dropdown appears above the modal
        setTimeout(() => {
          const pacContainers = document.getElementsByClassName('pac-container');
          for (let i = 0; i < pacContainers.length; i++) {
            const container = pacContainers[i] as HTMLElement;
            container.style.zIndex = '10000';
            
            // Ensure container is appended to body to avoid modal stacking context issues
            if (container.parentElement !== document.body) {
              document.body.appendChild(container);
            }
          }
        }, 300);

        // Create a marker for location selection
        this.marker = new google.maps.Marker({
          map: this.map,
          draggable: true,
          position: defaultLocation,
          animation: google.maps.Animation.DROP
        });

        // Add click listener to map
        this.map.addListener('click', (event: any) => {
          const position = event.latLng;
          this.marker.setPosition(position);
          this.updateCoordinates(position.lat(), position.lng());
        });

        // Update coordinates when marker is dragged
        this.marker.addListener('dragend', (event: any) => {
          const position = this.marker.getPosition();
          this.updateCoordinates(position.lat(), position.lng());
        });

        // Helper method to update coordinates
        this.updateCoordinates = (lat: number, lng: number) => {
          this.stopDetails.Latitude = lat.toFixed(6);
          this.stopDetails.Longitude = lng.toFixed(6);
          $('#component22').val(lat.toFixed(6));
          $('#component23').val(lng.toFixed(6));
        };

        // Single consolidated place_changed event listener
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          
          if (!place.geometry || !place.geometry.location) {
            return;
          }

          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          // If the place has a geometry, then present it on a map
          if (place.geometry.viewport) {
            this.map.fitBounds(place.geometry.viewport);
          } else {
            this.map.setCenter(place.geometry.location);
            this.map.setZoom(17);
          }

          // Update marker position with animation
          this.marker.setPosition(place.geometry.location);
          this.marker.setAnimation(google.maps.Animation.DROP);

          // Update all latitude and longitude fields for edit modal
          $('#component22').val(lat.toString());
          $('#component23').val(lng.toString());
          $('.stop-latit').val(lat.toString());
          $('.stop-long').val(lng.toString());
          
          // Update the component's data models
          this.stopDetails.Latitude = lat.toString();
          this.stopDetails.Longitude = lng.toString();

          // Clear the input field after selection
          (input as HTMLInputElement).value = place.formatted_address || place.name || '';

          // Trigger change event on the input fields
          $('#component22, #component23, .stop-latit, .stop-long').trigger('change');
        });

        // If stop already has coordinates, center the map there
        if (this.stopDetails.Latitude && this.stopDetails.Longitude) {
          const position = {
            lat: parseFloat(this.stopDetails.Latitude),
            lng: parseFloat(this.stopDetails.Longitude)
          };
          this.map.setCenter(position);
          this.marker.setPosition(position);
        }
      }, 300); // Small delay to ensure the modal is fully shown
    });
  }

  ngOnInit() {
    // Load the Google Maps JavaScript API
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDHWle0ySVx-1H7fKACXpMERZ01g9gyEIM&libraries=places`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    // Initialize map after API loads
    script.onload = () => {
      this.initializeMap();
      this.initializeAddMap();
    };

    this.scriptLoader.loadScript($,"DASHBOARD");
    this.loginMode = localStorage.getItem('loginMode');
    this.currType =localStorage.getItem('currency') || 'INR';
    if(this.loginMode == "STAFF"){
      this.router.navigate(['/exams']);
    }
    this.isValidToken();

    this.assignStopsPopupClone = $("#addanotherStopParent").clone(true);
     this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getTransportCall(this.activeTab);
      this.getActiveBuses();
      this.getInActiveBuses();
    });
  }

  ngOnDestroy() {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }



  loading = false;
  currentAcademicYear = {Year:null,isTransportMigrationStarted:null,pkAcademicId:null};
  previousAcademic = {Year:null,pkAcademicId:null};
  migrationStarted = false;
  currentAndPreviousAcademic(){
    this.migrationStarted = false;
    this.transportservice.currentAndPreviousAcademicService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          }
          else {
            this.currentAcademicYear = data.academic;
            this.previousAcademic = data.previousAcademic;
            this.migrationStarted = this.currentAcademicYear.isTransportMigrationStarted == "YES";
          }
        },
        error =>
          () => {

          }
      );
  }

  migrateTransport(){
    this.loading = true;
    let academic = {
      oldAcademicId:this.previousAcademic.pkAcademicId,
      currentAcademicId:this.currentAcademicYear.pkAcademicId
    };
    this.transportservice.migrateTransportService(academic, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          this.loading = false;
          if(data.success){
            const transportMigrationSuccessfullyCompletedTranslation = await firstValueFrom(this.translate.get('transportMigrationSuccessfullyCompleted')); 
            customToastr(transportMigrationSuccessfullyCompletedTranslation, 'success');
            this.getTransportCall(this.activeTab);
          } else if(data.errmessage == this.strings.migrationNotAllowed){
            const transportIsAlredayConfiguredForTheSelectedAcademicYearTranslation = await firstValueFrom(this.translate.get('transportIsAlredayConfiguredForTheSelectedAcademicYear')); 
            customToastr(transportIsAlredayConfiguredForTheSelectedAcademicYearTranslation, 'error');
          } else{
            const transportMigrationNotCompletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('transportMigrationNotCompletedPleaseTryAgain')); 
            customToastr(transportMigrationNotCompletedPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          this.loading = false;
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  getTransportCall(tab){
    this.activeTab = tab;
    this.currentAndPreviousAcademic();
    this.getTransportCount();
    this.getDriverList();
    this.getRouteList();
    if(this.activeTab == 'TERMS'){
      this.getAllStopTerms();
    }
    else if (this.activeTab == 'ROUTE') {
      this.getBusStop();
    }
    else if(this.activeTab == 'STOP'){
      this.getBusStop();
      this.assignStop();
    }
    else {
      if(this.selectedBusListType == 'all'){
        this.getAllBuses();
      }
      else if(this.selectedBusListType == 'active'){
        this.getActiveBuses();
      }
      else if(this.selectedBusListType == 'inactive'){
        this.getInActiveBuses();
      }
    }
  }

}
